(function () {
  if (window.SolaMotion) return;
  window.SolaMotion = { ready: false };
  var root = document.documentElement;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function motionOn() { return !reduce && root.classList.contains('sola-motion'); }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  function scan(scope) {
    var els = (scope || document).querySelectorAll('[data-sola-reveal]:not(.is-in)');
    for (var i = 0; i < els.length; i++) {
      if (io && motionOn()) io.observe(els[i]);
      else els[i].classList.add('is-in');
    }
  }

  // Claim markers: render every '*' as a small, faded superscript
  function marks(scope) {
    var base = scope || document.querySelector('main') || document.body;
    if (!base || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(base, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('*') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION|NOSCRIPT|SUP)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var parts = n.nodeValue.split('*');
      var frag = document.createDocumentFragment();
      parts.forEach(function (txt, i) {
        if (txt) frag.appendChild(document.createTextNode(txt));
        if (i < parts.length - 1) {
          var s = document.createElement('sup');
          s.className = 'sola-fn';
          s.textContent = '*';
          frag.appendChild(s);
        }
      });
      n.parentNode.replaceChild(frag, n);
    });
  }

  var layers = [];
  function collect() {
    layers = Array.prototype.slice.call(document.querySelectorAll('[data-sola-parallax]'));
  }
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight || 800;
    for (var i = 0; i < layers.length; i++) {
      var el = layers[i];
      var host = el.parentElement;
      if (!host) continue;
      var r = host.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-sola-parallax')) || 0.1;
      var offset = (r.top + r.height / 2 - vh / 2) * -speed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }

  function init() {
    try { marks(); } catch (e) {}
    scan(document);
    if (motionOn()) {
      collect();
      frame();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    window.SolaMotion.ready = true;
    window.SolaMotion.scan = scan;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    try { marks(e.target); } catch (err) {}
    scan(e.target);
    collect();
  });
})();
